export class User {
  private _active: boolean;
  private _id: number;
  private _firstName: string;
  private _lastName: string;
  private _emailAddress: string;

  get active(): boolean {
    return this._active;
  }

  set active(value: boolean) {
    this._active = value;
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get firstName(): string {
    return this._firstName;
  }

  set firstName(value: string) {
    this._firstName = value;
  }

  get lastName(): string {
    return this._lastName;
  }

  set lastName(value: string) {
    this._lastName = value;
  }

  get emailAddress(): string {
    return this._emailAddress;
  }

  set emailAddress(value: string) {
    this._emailAddress = value;
  }

  toString(): string {
    return `${this._firstName || ''} ${this._lastName || ''}`;
  }

  toLastFirstName(): string {
    return `${this._lastName || ''}, ${this._firstName || ''}`;
  }
}
